/**
 * Product recommendations - fetch when section scrolls into view.
 * Uses pre-rendered tag fallback when API returns 0 recommendations.
 */
(function () {
  const section = document.querySelector('[data-product-recommendations]');
  if (!section || !section.dataset.url) return;

  const tagFallbackTemplate = section.querySelector('[data-tag-fallback]');

  const observer = new IntersectionObserver(
    (entries) => {
      const entry = entries[0];
      if (!entry.isIntersecting) return;

      observer.unobserve(section);
      fetch(section.dataset.url)
        .then((res) => res.text())
        .then((htmlText) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlText, 'text/html');
          const fetched = doc.querySelector('.product-recommendations');
          const hasNoProducts =
            fetched &&
            (fetched.textContent.includes('No related products found') ||
              !fetched.querySelector('.product-recommendations__card'));

          if (hasNoProducts && tagFallbackTemplate) {
            section.innerHTML = tagFallbackTemplate.innerHTML;
          } else if (fetched && fetched.innerHTML.trim().length > 0) {
            section.innerHTML = fetched.innerHTML;
          } else {
            const placeholder = section.querySelector('[data-recommendations-placeholder]');
            if (placeholder) {
              placeholder.textContent = 'No recommendations available.';
            }
          }
        })
        .catch(() => {
          if (tagFallbackTemplate) {
            section.innerHTML = tagFallbackTemplate.innerHTML;
          } else {
            const placeholder = section.querySelector('[data-recommendations-placeholder]');
            if (placeholder) {
              placeholder.textContent = 'Could not load recommendations.';
            }
          }
        });
    },
    { rootMargin: '0px 0px 150px 0px' }
  );

  observer.observe(section);
})();
